import React from 'react'
import { Routes, Route, BrowserRouter } from "react-router-dom";
import {
  Error,
  Login,
  ProtectedRouteUser,
  ProtectedRouteManager,
  ProtectedRouteAdmin,
  // ProtectedRouteDeveloper,
  CustomerReports,
  Warranty,
} from "./pages"; // Register,
import {
  AddJob,
  AllJobs,
  Admin,
  Appointments,
  Dashboard,
  JobSummary,
  Messages,
  SharedLayout,
  Payments,
  WorkSpecs,
  UserSettings,
  Reports
} from "./pages/workspace/index.js";

// Access to pages also controlled on ./utils/links.js

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Authenticated Users Only */}
        <Route
          path="/"
          element={
            <ProtectedRouteUser>
              <SharedLayout />
            </ProtectedRouteUser>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="all-jobs" element={<AllJobs />} />
          <Route path="add-job" element={<AddJob />} />
          <Route path="job-summary" element={<JobSummary />} />
          <Route
            path="messages"
            element={
              <ProtectedRouteAdmin>
                <Messages />
              </ProtectedRouteAdmin>
            }
          />
          <Route path="work-specs" element={<WorkSpecs />} />
          <Route path="user-settings" element={<UserSettings />} />
          {/* Managers Only */}
          <Route
            path="appointments"
            element={
              <ProtectedRouteManager>
                <Appointments />
              </ProtectedRouteManager>
            }
          />
          <Route
            path="payments"
            element={
              <ProtectedRouteManager>
                <Payments />
              </ProtectedRouteManager>
            }
          />
          {/* Admins Only */}
          <Route
            path="reports"
            element={
              <ProtectedRouteAdmin>
                <Reports />
              </ProtectedRouteAdmin>
            }
          />
          <Route
            path="admin"
            element={
              <ProtectedRouteAdmin>
                <Admin />
              </ProtectedRouteAdmin>
            }
          />
        </Route>
        {/* Reports PDF Route */}
        <Route
          path="customer-reports/:jobId"
          element={
            <ProtectedRouteUser>
              <CustomerReports />
            </ProtectedRouteUser>
          }
        />
        {/* Warranty PDF Route */}
        <Route
          path="warranty/:jobId"
          element={
            <ProtectedRouteUser>
              <Warranty />
            </ProtectedRouteUser>
          }
        />
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
